import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import TallyIntegrationActions, { tallyIntegrationActionTypes } from '../../actions/integrations/tallyIntegrationActions';
import TallyIntegrationServices from '../../services/integrations/tallyIntegrationServices';

/**
 * @param action
 */
function* _getTallyConnections(action) {
  try {
    const {
      orgId, callback, tallyId
    } = action;
    yield put(TallyIntegrationActions.getTallyConnectionsLoading(true));
    const linkedTallyAccounts = yield TallyIntegrationServices.getTallyConnections(orgId, tallyId);
    yield put(TallyIntegrationActions.getTallyConnectionsSuccess(linkedTallyAccounts?.result));
    if (linkedTallyAccounts.success) {
      if (callback) {
        callback(linkedTallyAccounts.result);
      }
    }
    yield put(TallyIntegrationActions.getTallyConnectionsLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.getTallyConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.ERROR, error));
  }
}

/**
 *
 */
function* getTallyConnections() {
  yield takeLatest(tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.REQUEST, _getTallyConnections);
}

/**
 * @param action
 */
function* _deleteTallyConnection(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.deleteTallyConnectionLoading(true));
    const deleteConnection = yield TallyIntegrationServices.deleteTallyConnection(payload);
    if (deleteConnection.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Tally Connection Updated.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: deleteConnection.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.deleteTallyConnectionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.deleteTallyConnectionLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.DELETE_TALLY_CONNECTION.ERROR, error));
  }
}
/**
 *
 */
function* deleteTallyConnection() {
  yield takeLatest(tallyIntegrationActionTypes.DELETE_TALLY_CONNECTION.REQUEST, _deleteTallyConnection);
}

/**
 * @param action
 */
function* _connectToTally(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.connectToTallyLoading(true));
    const connectToTallyData = yield TallyIntegrationServices.connectToTally(payload);
    if (connectToTallyData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Your Tally account connection has been initiated.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: connectToTallyData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.connectToTallyLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.connectToTallyLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.CONNECT_TO_TALLY.ERROR, error));
  }
}
/**
 *
 */
function* connectToTally() {
  yield takeEvery(tallyIntegrationActionTypes.CONNECT_TO_TALLY.REQUEST, _connectToTally);
}

/**
 * @param action
 */
function* _connectTenantToTallyLocation(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.connectTenantToTallyLocationLoading(true));
    const connectToTallyData = yield TallyIntegrationServices.connectTenantToTallyLocation(payload);
    if (connectToTallyData.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: connectToTallyData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.connectTenantToTallyLocationLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.connectTenantToTallyLocationLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.CONNECT_TENANT_TO_TALLY_LOCATION.ERROR, error));
  }
}
/**
 *
 */
function* connectTenantToTallyLocation() {
  yield takeLatest(tallyIntegrationActionTypes.CONNECT_TENANT_TO_TALLY_LOCATION.REQUEST, _connectTenantToTallyLocation);
}

/**
 * @param action
 */
function* _syncProduct(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncProductLoading(true));
    const syncVendorData = yield TallyIntegrationServices.syncProduct(payload);
    if (syncVendorData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Product synced successfully with Tally.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncVendorData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncProductLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncProductLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_PRODUCT.ERROR, error));
  }
}
/**
 *
 */
function* syncProduct() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_PRODUCT.REQUEST, _syncProduct);
}

/**
 * @param action
 */
function* _syncVendor(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncVendorLoading(true));
    const syncVendorData = yield TallyIntegrationServices.syncVendor(payload);
    if (syncVendorData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Vendor synced successfully with Tally.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncVendorData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncVendorLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncVendorLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_VENDOR.ERROR, error));
  }
}
/**
 *
 */
function* syncVendor() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_VENDOR.REQUEST, _syncVendor);
}

/**
 * @param action
 */
function* _syncTallyGRN(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncTallyGRNLoading(true));
    const syncGRNData = yield TallyIntegrationServices.syncTallyGRN(payload);
    if (syncGRNData.success) {
      if (callback) {
        callback();
      }
      let entityName = '';
      if (payload?.dn_id) {
        entityName = 'Debit Note';
      } else if (payload?.ap_invoice_id) {
        entityName = 'AP Invoice';
      } else if (payload?.expense_id) {
        entityName = 'Expense';
      } else {
        entityName = 'GRN';
      }
      notification.open({
        type: 'success',
        message: `The request to sync the ${entityName} with Tally is in progress. This may take 3-5 minutes.`,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncGRNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncTallyGRNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncTallyGRNLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_GRN.ERROR, error));
  }
}

/**
 *
 */
function* syncTallyGRN() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_GRN.REQUEST, _syncTallyGRN);
}

/**
 * @param action
 */
function* _syncTallyInvoice(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncTallyInvoiceLoading(true));
    const syncInvoiceData = yield TallyIntegrationServices.syncTallyInvoice(payload);
    if (syncInvoiceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'The request to sync Invoice with Tally is in progress. This may take 3-5 minutes.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncInvoiceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncTallyInvoiceLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncTallyInvoiceLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_INVOICE.ERROR, error));
  }
}

/**
 *
 */
function* syncTallyInvoice() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_INVOICE.REQUEST, _syncTallyInvoice);
}

/**
 * @param action
 */
function* _syncTallyCreditNote(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncTallyCreditNoteLoading(true));
    const syncCNData = yield TallyIntegrationServices.syncTallyCreditNote(payload);
    if (syncCNData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'The request to sync Credit Notes with Tally is in progress. This may take 3-5 minutes.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncCNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncTallyCreditNoteLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncTallyCreditNoteLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_CN.ERROR, error));
  }
}

/**
 *
 */
function* syncTallyCreditNote() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_CN.REQUEST, _syncTallyCreditNote);
}

/**
 * @param action
 */
function* _syncPO(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncPOLoading(true));
    const syncPOData = yield TallyIntegrationServices.syncPO(payload);
    if (syncPOData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Purchase Order synced successfully with Tally.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncPOData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncPOLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncPOLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_PO.ERROR, error));
  }
}
/**
 *
 */
function* syncPO() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_PO.REQUEST, _syncPO);
}

/**
 * @param action
 */
function* _syncDN(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncDNLoading(true));
    const syncDNData = yield TallyIntegrationServices.syncDN(payload);
    if (syncDNData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Debit Note synced successfully with Tally.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncDNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncDNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncDNLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_DN.ERROR, error));
  }
}
/**
 *
 */
function* syncDN() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_DN.REQUEST, _syncDN);
}

/**
 * @param action
 */
function* _pullTallyProducts(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.pullTallyProductsLoading(true));
    const pullTallyProductsData = yield TallyIntegrationServices.pullTallyProducts(payload);
    if (pullTallyProductsData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your products data from Tally  to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullTallyProductsData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(TallyIntegrationActions.pullTallyProductsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.pullTallyProductsLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.PULL_TALLY_PRODUCTS.ERROR, error));
  }
}
/**
 *
 */
function* pullTallyProducts() {
  yield takeLatest(tallyIntegrationActionTypes.PULL_TALLY_PRODUCTS.REQUEST, _pullTallyProducts);
}

/**
 * @param action
 */
function* _pullTallyVendors(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.pullTallyVendorsLoading(true));
    const pullTallyVendorsData = yield TallyIntegrationServices.pullTallyVendors(payload);
    if (pullTallyVendorsData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your vendors data from Tally  to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullTallyVendorsData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(TallyIntegrationActions.pullTallyVendorsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.pullTallyVendorsLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.PULL_TALLY_VENDORS.ERROR, error));
  }
}
/**
 *
 */
function* pullTallyVendors() {
  yield takeLatest(tallyIntegrationActionTypes.PULL_TALLY_VENDORS.REQUEST, _pullTallyVendors);
}

/**
 * @param action
 */
function* _pullTallyVendorPayment(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.pullTallyVendorPaymentLoading(true));
    const pullVendorPaymentData = yield TallyIntegrationServices.pullTallyVendorPayment(payload);
    if (pullVendorPaymentData.success) {
      notification.open({
        type: 'success',
        message: 'Request to sync GRN payment is in progress. This may take 3-5 minutes.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullVendorPaymentData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(TallyIntegrationActions.pullTallyVendorPaymentLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.pullTallyVendorPaymentLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.PULL_TALLY_VENDOR_PAYMENT.ERROR, error));
  }
}
/**
 *
 */
function* pullTallyVendorPayment() {
  yield takeLatest(tallyIntegrationActionTypes.PULL_TALLY_VENDOR_PAYMENT.REQUEST, _pullTallyVendorPayment);
}

/**
 * @param action
 */
function* _refreshTallyConnections(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.refreshTallyConnectionsLoading(true));
    const tallyData = yield TallyIntegrationServices.refreshTallyConnections(payload);
    if (tallyData.success) {
      notification.open({
        type: 'success',
        message: 'Refreshed tally connections.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: tallyData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(TallyIntegrationActions.refreshTallyConnectionsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.refreshTallyConnectionsLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.REFRESH_TALLY_CONNECTIONS.ERROR, error));
  }
}
/**
 *
 */
function* refreshTallyConnections() {
  yield takeLatest(tallyIntegrationActionTypes.REFRESH_TALLY_CONNECTIONS.REQUEST, _refreshTallyConnections);
}
/**
 * @param action
 */
function* _pullTallyCustomers(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.pullTallyCustomersLoading(true));
    const pullTallyCustomersData = yield TallyIntegrationServices.pullTallyCustomers(payload);
    if (pullTallyCustomersData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your customers data from Tally to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullTallyCustomersData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(TallyIntegrationActions.pullTallyCustomersLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.pullTallyCustomersLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.PULL_TALLY_CUSTOMERS.ERROR, error));
  }
}
/**
 *
 */
function* pullTallyCustomers() {
  yield takeLatest(tallyIntegrationActionTypes.PULL_TALLY_CUSTOMERS.REQUEST, _pullTallyCustomers);
}

/**
 * @param action
 */
function* _getTallyDocuments(action) {
  try {
    const {
      tenantIds, documentType, startDate, endDate, page, limit, entityName, callback,
    } = action;
    yield put(TallyIntegrationActions.getTallyDocumentsLoading(true));
    const result = yield TallyIntegrationServices.getTallyDocuments(tenantIds, documentType, startDate, endDate, page, limit, entityName);
    yield put(TallyIntegrationActions.getTallyDocumentsSuccess(result));
    if (result.success && callback) {
      callback(result);
    }
    yield put(TallyIntegrationActions.getTallyDocumentsLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.getTallyDocumentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.ERROR, error));
  }
}

/**
 *
 */
function* getTallyDocuments() {
  yield takeLatest(tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.REQUEST, _getTallyDocuments);
}

/**
 * @param action
 */
function* _getTallyUnMappedDocuments(action) {
  try {
    const {
      tenantIds, startDate, endDate, page, limit, callback,
    } = action;
    yield put(TallyIntegrationActions.getTallyUnMappedDocumentsLoading(true));
    const result = yield TallyIntegrationServices.getTallyUnMappedDocuments(tenantIds, startDate, endDate, page, limit);
    yield put(TallyIntegrationActions.getTallyUnMappedDocumentsSuccess(result));
    if (result.success && callback) {
      callback(result);
    }
    yield put(TallyIntegrationActions.getTallyUnMappedDocumentsLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.getTallyUnMappedDocumentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.ERROR, error));
  }
}

/**
 *
 */
function* getTallyUnMappedDocuments() {
  yield takeLatest(tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.REQUEST, _getTallyUnMappedDocuments);
}

/**
 * @param action
 */
function* _syncTallyDocuments(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.syncTallyDocumentsLoading(true));
    const result = yield TallyIntegrationServices.syncTallyDocuments(payload);
    if (result.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'The request is completed, please check the status.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: result.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.syncTallyDocumentsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.syncTallyDocumentsLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.SYNC_TALLY_DOCUMENTS.ERROR, error));
  }
}

/**
 *
 */
function* syncTallyDocuments() {
  yield takeLatest(tallyIntegrationActionTypes.SYNC_TALLY_DOCUMENTS.REQUEST, _syncTallyDocuments);
}

function* _updateTallyDocuments(action) {
  try {
    const { payload, callback } = action;
    yield put(TallyIntegrationActions.updateTallyDocumentsLoading(true));
    const result = yield TallyIntegrationServices.updateTallyDocuments(payload);
    if (result.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: result.message || 'updated successfully',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: result.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TallyIntegrationActions.updateTallyDocumentsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TallyIntegrationActions.updateTallyDocumentsLoading(false));
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.UPDATE_TALLY_EXCLUDED_DOCUMENTS.ERROR, error));
  }
}

/**
 *
 */
function* updateTallyDocuments() {
  yield takeLatest(tallyIntegrationActionTypes.UPDATE_TALLY_EXCLUDED_DOCUMENTS.REQUEST, _updateTallyDocuments);
}

/**
 * @param action
 */
function* _getTallyDocumentsCount(action) {
  try {
    const {
      tenantIds, callback,
    } = action;
    yield put(TallyIntegrationActions.getTallyDocumentsCountLoading(true));
    const result = yield TallyIntegrationServices.getTallyDocumentsCount(tenantIds);
    yield put(TallyIntegrationActions.getTallyDocumentsCountSuccess(result));
    if (result.success && callback) {
      callback(result);
    }
    yield put(TallyIntegrationActions.getTallyDocumentsCountLoading(false));
  } catch (error) {
    yield put(TallyIntegrationActions.getTallyDocumentsCountLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.ERROR, error));
  }
}

/**
 *
 */
function* getTallyDocumentsCount() {
  yield takeLatest(tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.REQUEST, _getTallyDocumentsCount);
}
/**
 *
 */
export default function* tallyIntegrationSaga() {
  yield all([
    getTallyConnections(),
    deleteTallyConnection(),
    connectToTally(),
    connectTenantToTallyLocation(),
    syncProduct(),
    syncVendor(),
    syncTallyGRN(),
    syncPO(),
    syncDN(),
    pullTallyProducts(),
    pullTallyVendors(),
    pullTallyVendorPayment(),
    refreshTallyConnections(),
    syncTallyInvoice(),
    syncTallyCreditNote(),
    pullTallyCustomers(),
    getTallyDocuments(),
    getTallyUnMappedDocuments(),
    syncTallyDocuments(),
    updateTallyDocuments(),
    getTallyDocumentsCount(),
  ]);
}
